import app from '@/app';

/* @ngInject */
function errorHandlerInterceptor($q, $injector) {
  this.responseError = function (response) {
    if (response.config && response.config.url && response.config.url.indexOf('/api/plans/status') !== -1) {
      return $q.reject(response);
    }

    // The password reset component handles its own error (the 72h message);
    // suppress the global alert to avoid showing a duplicate error box.
    if (response.config && response.config.url && response.config.url.indexOf('/api/account/reset-password/finish') !== -1) {
      return $q.reject(response);
    }

    var AlertService = $injector.get('AlertService');
    switch (response.status) {
      case 0:
        AlertService.error('message.server.unreachable');
        break;
      case 400:
        if (response.config && response.config.url && response.config.url.indexOf('/api/import/excel') !== -1) {
            break;
        }
        if (response.data) {
          if (response.data.fieldErrors) {
            for (var index in response.data.fieldErrors) {
              var error = response.data.fieldErrors[index];
              AlertService.error('message.' + error.code, {
                entity: error.objectName,
                field: error.field.replace(/\[\d*\]/g, '[]')
              });
            }
          } else if (response.data.code) {
            AlertService.error('message.' + response.data.code, response.data);
          } else {
            AlertService.error(response.data);
          }
        } else {
          AlertService.error(response.status);
        }
        break;
      case 401:
        if (
          !(
            response.data === '' ||
            (response.data.path &&
              (response.data.path.includes('/api/users/current') ||
                response.data.path.includes('/api/account')))
          )
        ) {
          AlertService.error('login.failed');
        }
        break;
      case 403:
        AlertService.error('message.resource.forbidden');
        break;
      case 404:
        if (response.data.path && !response.data.path.includes('/api/account')) {
          AlertService.error('message.resource.notfound');
        }
        break;
      case 504:
        break;
      default:
        if (response.data && response.data.message) {
          AlertService.error(response.data.message);
        } else {
          // Show a readable message instead of dumping the raw response object as JSON.
          AlertService.error('message.unexpectedError');
        }
    }
    return $q.reject(response);
  };
}

app.service('errorHandlerInterceptor', errorHandlerInterceptor);
